document.addEventListener("alpine:init", () => {
  Alpine.store("facetsModal", {
    isOpen: false,
    activeTab: "search",
    bodyClass: "overflow-hidden-mobile",

    init() {
      document.addEventListener("facets-modal:toggle", this.toggle.bind(this));
    },

    toggle() {
      this.isOpen ? this.hide() : this.show();
    },

    show() {
      this.isOpen = true;
      document.body.classList.add(this.bodyClass);
      document.querySelector("header").classList.add("m-white-bg");
    },

    hide() {
      this.isOpen = false;
      document.body.classList.remove(this.bodyClass);
      document.querySelector("header").classList.remove("m-white-bg");
    },

    // Mobile tab functions
    toggleActiveTab(index) {
      this.activeTab = index;
    },
    // END: Mobile tab functions
  });
});
